import doorPlacementTypes from 'components/configurator/types/doorPlacementTypes';
import getDoorPosition from 'components/configurator/services/getDoorPosition';
import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';
import {
  isSlidyDoor,
  isWoodyDoubleDoor,
  isWoodyBox,
  isAluDoubleDoor,
  isAluLeafDoorGlassAbove,
  isAluDoorElectricityBox,
} from '../types/doorTypes';
import { LEFT, RIGHT } from '../types/doorHangTypes';

const handleFirstAndLastDoorSettings = (
  doors: IGlassWallDoor[],
  wall: IWall
): IGlassWallDoor[] =>
  doors.map((door: IGlassWallDoor, index: number) => {
    const hasLeftElectricalBox = () => {
      return door.woodyLeftElectricalBox;
    };

    const hasRightElectricalBox = () => {
      return door.woodyRightElectricalBox;
    };

    const hasIncludedLeftExtraWoodyProfile = () => {
      return door.woodyLeftExtraWoodyProfile;
    };

    const hasIncludedRightExtraWoodyProfile = () => {
      return door.woodyRightExtraWoodyProfile;
    };

    if (index === 0 && door.isFirstDoor) {
      const doorPosition = getDoorPosition(door, wall);
      let turningDoorOffset =
        isSlidyDoor(door) || door.doorHang === RIGHT
          ? 0
          : door.doorOpeningWidth;

      const woodyDoubleDoorOffset =
        door.doorHang === RIGHT ? door.woodyDoorPositionOffset : 0;

      turningDoorOffset =
        isWoodyDoubleDoor(door) || isAluDoubleDoor(door)
          ? door.doorOpeningWidth / 2
          : turningDoorOffset;

      turningDoorOffset =
        isWoodyDoubleDoor(door) && !hasLeftElectricalBox()
          ? turningDoorOffset + woodyDoubleDoorOffset
          : turningDoorOffset;

      let insertPosition =
        doorPosition.verticalProfileOffsets.left +
        turningDoorOffset +
        wall.leftWallOffset;

      insertPosition =
        hasLeftElectricalBox() && !isWoodyBox(door)
          ? insertPosition + door.woodyLeftElectricalBoxWidth
          : insertPosition;

      insertPosition = hasIncludedLeftExtraWoodyProfile()
        ? insertPosition + door.woodyLeftExtraProfileHeight
        : insertPosition;

      // Adjusting for 'Aluminium door electrical box'
      // As we are in 'door first' mode, adjust for the left electrical box (which is controlled by woodyRightElectricalBox for whatever reason........)
      // NOTE: if isAluLeafDoorGlassAbove starts to work this dorr will be removed
      if (isAluDoorElectricityBox(door)) {
        if (door.woodyRightElectricalBox) {
          if (door.doorHang === RIGHT) {
            insertPosition += door.woodyRightElectricalBoxWidth;
          }
        }
      }

      // Only other aluminium door with electrical box support
      // Electrical boxes rotate *with* the door in this case. So if left hang, left and right electrical boxes flip.
      if (isAluLeafDoorGlassAbove(door)) {
        // If right hang, adjust for the left electrical box (if present)
        if (door.doorHang === RIGHT && door.woodyLeftElectricalBox) {
          insertPosition -= door.woodyLeftElectricalBoxWidth;
        }
        // If left hang, adjust for the right electrical box (if present)
        if (door.doorHang === LEFT && door.woodyRightElectricalBox) {
          insertPosition += door.woodyRightElectricalBoxWidth;
        }
      }

      return {
        ...door,
        doorPlacementType: doorPlacementTypes.first,
        insertPosition,
      };
    }

    if (index === doors.length - 1 && door.isLastDoor) {
      const doorPosition = getDoorPosition(door, wall);
      let turningDoorOffset =
        isSlidyDoor(door) || door.doorHang === LEFT ? 0 : door.doorOpeningWidth;

      const woodyDoubleDoorOffset =
        door.doorHang === LEFT ? door.woodyDoorPositionOffset : 0;

      turningDoorOffset =
        isWoodyDoubleDoor(door) || isAluDoubleDoor(door)
          ? door.doorOpeningWidth / 2
          : turningDoorOffset;

      turningDoorOffset =
        isWoodyDoubleDoor(door) && !hasRightElectricalBox()
          ? turningDoorOffset + woodyDoubleDoorOffset
          : turningDoorOffset;

      let insertPosition =
        wall.length -
        doorPosition.verticalProfileOffsets.right -
        turningDoorOffset -
        wall.rightWallOffset;

      insertPosition =
        hasRightElectricalBox() && !isWoodyBox(door)
          ? insertPosition - door.woodyRightElectricalBoxWidth
          : insertPosition;

      insertPosition = hasIncludedRightExtraWoodyProfile()
        ? insertPosition - door.woodyRightExtraProfileHeight
        : insertPosition;

      // Adjusting for 'Aluminium door electrical box'
      // As we are in 'door first' mode, adjust for the left electrical box (which is controlled by woodyRightElectricalBox for whatever reason........)
      // NOTE: if isAluLeafDoorGlassAbove starts to work this dorr will be removed
      if (isAluDoorElectricityBox(door) && door.woodyRightElectricalBox) {
        if (door.doorHang === RIGHT) {
          insertPosition += door.woodyRightElectricalBoxWidth;
        }
      }

      // Only other aluminium door with electrical box support
      // Electrical boxes rotate *with* the door in this case. So if left hang, left and right electrical boxes flip.
      if (isAluLeafDoorGlassAbove(door)) {
        // If right hang, adjust for the left electrical box (if present)
        if (door.doorHang === RIGHT && door.woodyLeftElectricalBox) {
          insertPosition -= door.woodyLeftElectricalBoxWidth;
        }
        // If left hang, adjust for the right electrical box (if present)
        if (door.doorHang === LEFT && door.woodyRightElectricalBox) {
          insertPosition += door.woodyRightElectricalBoxWidth;
        }
      }

      return {
        ...door,
        doorPlacementType: doorPlacementTypes.last,
        insertPosition,
      };
    }

    return {
      ...door,
      doorPlacementType: doorPlacementTypes.middle,
    };
  });

export default handleFirstAndLastDoorSettings;
